import { Component, OnInit, OnDestroy, HostListener, ViewChild } from '@angular/core';
import { SearchTransactionHistoryRequestModel } from '../../model/searchTransactionHistoryRequestModel';
import { SearchTransactionHistoryResponseModel } from '../../model/searchTransactionHistoryResponseModel';
import { TransactionsService } from '../transactions.service';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { MatTableDataSource, MatSort } from '@angular/material';

@Component({
  selector: 'app-transaction-history-broker',
  templateUrl: './transaction-history-broker.component.html',
  styleUrls: ['./transaction-history-broker.component.css']
})
export class TransactionHistoryBrokerComponent implements OnInit, OnDestroy {
  
  title = " View Employee Transaction History ";
  loading: boolean = false;
  startDate:Date;
  endDate:Date;
  
  transactionHistoryRequestModel = new SearchTransactionHistoryRequestModel();
  brokerTransactionHistory = new SearchTransactionHistoryResponseModel();

  transactionHistory : TransactionBrokerHistoryModel[] = [];

  displayedColumns = ['Name', 'LicenseNumber','Activity', 'DateSubmitted' , 'DateDue','DateApproved', 'Result' ];

  dataSource ;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private transactionsService: TransactionsService ,private currentPageWatcherService: CurrentPageWatcherService, 
    private spinner: SpinnerService,private router:Router) {
      this.transactionHistoryRequestModel = this.transactionsService.transactionHistoryRequestModel;
      this.startDate = this.transactionHistoryRequestModel.StartDate;
      this.endDate = this.transactionHistoryRequestModel.EndDate;
   }

  ngOnInit() {
    this.currentPageWatcherService.pageChanged().emit(this.title);

    this.transactionsService.getBrokerTransactionHistory(this.transactionHistoryRequestModel)
    .subscribe(brokerTransResp => {   
          this.brokerTransactionHistory = brokerTransResp;
          this.brokerTransactionHistory.TransactionHistory.forEach(el=>{
            let transation = new TransactionBrokerHistoryModel();
            transation.Name = el.Name;
            transation.LicenseNumber = el.LicenseNumber;
            transation.Activity = el.ActionType;
            transation.DateSubmitted = el.DateSubmitted;
            transation.DateDue = el.DateDue;
            transation.DateApproved = el.DateProcessed;
            transation.Result = el.Result;
            this.transactionHistory.push(transation);
          });

          this.dataSource = new MatTableDataSource(this.transactionHistory);
          this.dataSource.sort = this.sort;
          console.log("Broker History transaction ", brokerTransResp);
          this.loading = false;
        
        });

  
  }

  goBackHome(){
    this.router.navigate(['/home']);
  }

  onNewRequest(){
    this.router.navigate(['/transactionHistoryBrokerSearch'])
      .then(() => {

        this.transactionsService.notifyTransactionBrokerHistoryModel.emit(this.transactionHistoryRequestModel);

      }
      );
  }
  
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.onNewRequest();
  }
  ngOnDestroy(): void {
    this.currentPageWatcherService.clearUserMessage();
    this.currentPageWatcherService.clearStepMessage();
  }

}

export class TransactionBrokerHistoryModel {  
 
  /**
   * Name of the Individual or Entity license
   */
  Name?: string;
  /**
   * License Number of the Individual or Entity license
   */
  LicenseNumber?: string;
   /**
   * Description of the action
   */
  Activity?: string;
  /**
   * Date the transaction was submitted
   */
  DateSubmitted?: Date;
  /**
   * Date the transaction was due
   */
  DateDue?: Date;
  DateApproved?: Date;
  /**
     * Description of the result of the approval process
     */
    Result?: string;
}



// WEBPACK FOOTER //
// ./src/app/transactions/transaction-history-broker/transaction-history-broker.component.ts